import Flickity from "flickity";
import "flickity/css/flickity.css";
import "flickity-fade";

function initCarousels() {
  const carouselEls = document.querySelectorAll("[data-carousel]");
  if (!carouselEls.length) return;

  carouselEls.forEach((carouselEl) => {
    const carouselListEl = carouselEl.querySelector("[data-carousel-list]");
    const carouselItemEls = carouselEl.querySelectorAll("[data-carousel-item]");
    const carouselNavEl = carouselEl.querySelector(".carousel__nav");
    const carouselPrevBtnEl = carouselEl.querySelector("[data-carousel-prev]");
    const carouselNextBtnEl = carouselEl.querySelector("[data-carousel-next]");

    if (!carouselListEl) return;

    let carouselSettings = {};

    try {
      carouselSettings = JSON.parse(
        carouselEl.getAttribute("data-carousel-settings") || "{}",
      );
    } catch (error) {
      console.warn("Invalid data-carousel-settings JSON.", error);
      return;
    }

    carouselListEl.style.display = "block";

    if (
      window.innerWidth > 1120 &&
      !!carouselSettings.disableItemsDesktop &&
      carouselSettings.disableItemsDesktop >= carouselItemEls.length
    ) {
      carouselListEl.style.display = "";
      carouselListEl.classList.add("carousel__list--disable");

      if (carouselNavEl) {
        carouselNavEl.remove();
      }

      return;
    }

    const isFade = !!carouselSettings.fade;
    const isFreeScroll = !!carouselSettings.freeScroll && !isFade;
    const isAutoScroll =
      !!carouselSettings.autoScroll &&
      !isFade &&
      !isFreeScroll &&
      !carouselSettings.autoPlay;
    const isAutoPlay = !!carouselSettings.autoPlay && !isAutoScroll;

    const flickityOptions = {
      accessibility: true,
      resize: true,
      percentPosition: true,
      setGallerySize: true,
      fade: isFade,
      cellAlign:
        !isFade && !isFreeScroll
          ? carouselSettings.cellAlign || "center"
          : "left",
      contain: !isFade && !isFreeScroll ? !!carouselSettings.contain : false,
      freeScroll: isFreeScroll,
      wrapAround:
        typeof carouselSettings.wrapAround === "boolean"
          ? carouselSettings.wrapAround
          : true,
      draggable:
        typeof carouselSettings.draggable === "boolean"
          ? carouselSettings.draggable
          : true,
      prevNextButtons: false,
      pageDots:
        typeof carouselSettings.pageDots === "boolean"
          ? carouselSettings.pageDots
          : false,
      autoPlay: isAutoPlay ? carouselSettings.autoPlay : false,
      pauseAutoPlayOnHover:
        typeof carouselSettings.pauseAutoPlayOnHover === "boolean"
          ? carouselSettings.pauseAutoPlayOnHover
          : true,
      imagesLoaded:
        typeof carouselSettings.imagesLoaded === "boolean"
          ? carouselSettings.imagesLoaded
          : true,
    };

    const flickityInstance = new Flickity(carouselListEl, flickityOptions);

    if (carouselSettings.showOverFlow && !isFade) {
      const flickityViewportEl =
        carouselListEl.querySelector(".flickity-viewport");

      carouselListEl.style.overflow = "visible";
      if (flickityViewportEl) {
        flickityViewportEl.style.overflow = "visible";
      }
    }

    if (carouselNavEl) {
      carouselNavEl.style.display = carouselSettings.showNavigation
        ? ""
        : "none";
    }

    if (carouselPrevBtnEl) {
      carouselPrevBtnEl.addEventListener("click", () => {
        flickityInstance.previous();
      });
    }

    if (carouselNextBtnEl) {
      carouselNextBtnEl.addEventListener("click", () => {
        flickityInstance.next();
      });
    }

    if (flickityInstance.slides.length <= 1) {
      if (carouselNavEl) {
        carouselNavEl.style.display = "none";
      }
      return;
    }

    if (isAutoScroll) {
      let requestId = null;
      let isPaused = false;
      const autoScrollSpeed =
        typeof carouselSettings.autoScrollSpeed === "number"
          ? carouselSettings.autoScrollSpeed
          : 0.7;

      flickityInstance.x = 0;
      flickityInstance.settle(flickityInstance.x);

      function play() {
        if (isPaused) return;
        flickityInstance.x -= autoScrollSpeed;
        flickityInstance.settle(flickityInstance.x);
        requestId = window.requestAnimationFrame(play);
      }

      function start() {
        if (requestId) return;
        isPaused = false;
        requestId = window.requestAnimationFrame(play);
      }

      function pause() {
        isPaused = true;
        if (requestId) {
          window.cancelAnimationFrame(requestId);
          requestId = null;
        }
      }

      start();

      if (carouselSettings.pauseAutoPlayOnHover !== false) {
        carouselEl.addEventListener("mouseenter", pause);
        carouselEl.addEventListener("mouseleave", start);
        carouselEl.addEventListener("focusin", pause);
        carouselEl.addEventListener("focusout", start);
        carouselEl.addEventListener("touchstart", pause, { passive: true });
        carouselEl.addEventListener("touchend", start);
      }

      window.addEventListener("blur", pause);
      window.addEventListener("focus", start);
    }
  });
}

function normalizeCarouselHeights() {
  const carouselEls = document.querySelectorAll("[data-carousel]");

  carouselEls.forEach((carouselEl) => {
    const carouselItemEls = carouselEl.querySelectorAll("[data-carousel-item]");
    if (!carouselItemEls.length) return;

    let tallest = 0;

    carouselItemEls.forEach((item) => {
      item.style.height = "";
      if (item.offsetHeight > tallest) {
        tallest = item.offsetHeight;
      }
    });

    carouselItemEls.forEach((item) => {
      item.style.height = `${tallest}px`;
    });
  });
}

function bootCarousels() {
  normalizeCarouselHeights();
  initCarousels();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootCarousels);
} else {
  bootCarousels();
}
